import { datadogRum } from '@datadog/browser-rum';
import type { DatadogRum } from '@datadog/browser-rum';
import { init } from '@servicetitan/datadog-rum';

const MOBILE_WEBVIEW_APPLICATION_ID = '2d511190-aa0f-4bbb-ac5a-5c700f5bca3b';
const MOBILE_WEBVIEW_CLIENT_TOKEN = 'pub32a0b8d0f4bb0ea010a74101eae4375a';

/** Named before the MFE loads, so a failure to load it is attributable to something. */
const HOST_VIEW_NAME = '/cpb-host';

export const guardRumGlobal = (instance: DatadogRum): void => {
    try {
        Object.defineProperty(window, 'DD_RUM', {
            configurable: true,
            enumerable: true,
            get: () => instance,
            set: attempted => {
                // eslint-disable-next-line no-console -- the clobber must be visible locally too
                console.warn('[DD_RUM guard] blocked window.DD_RUM reassignment', attempted);
                instance.addAction('dd-rum-reassignment-blocked');
            },
        });
    } catch (error) {
        // eslint-disable-next-line no-console -- installing the guard is the whole point
        console.error('[DD_RUM guard] failed to install', error);
    }
};

export const initializeHostDatadog = (): void => {
    if (!MOBILE_WEBVIEW_CLIENT_TOKEN) {
        return;
    }

    try {
        init({
            service: { name: 'contract-builder' },
            application: {
                applicationId: MOBILE_WEBVIEW_APPLICATION_ID,
                clientToken: MOBILE_WEBVIEW_CLIENT_TOKEN,
                site: 'datadoghq.com',
                trackViewsManually: true,
                trackUserInteractions: true,
                trackResources: true,
                trackLongTasks: true,
            },
        });

        if (!datadogRum.getInitConfiguration()) {
            return;
        }

        guardRumGlobal(datadogRum);
        datadogRum.startView({ name: HOST_VIEW_NAME });
    } catch {
        // ignored
    }
};

export const reportHostError = (message: string, context?: Record<string, unknown>): void => {
    try {
        datadogRum.addError(new Error(message), context ? { cpbHost: context } : undefined);
    } catch {
        // ignored
    }
};
